import { createWorkOrderSlice } from 'common/stores/redux/WorkOrder';

const adminWorkOrderSlice = createWorkOrderSlice('adminWorkOrder');

export const {
    init,
    replace,
    update,
    replaceSnapshot,
    updateKeyValuePair,
    updateInstructions,
    updateContact,
    addNote,
    updateNote,
    setNotes,
    addComment,
    updateComment,
    initFinancialInformation,
    updatePayment,
    updateBilling,
    addPhoto,
    removePhoto,
    addFolderAttachment,
    removeFolderAttachment,
    setFinanceEdit,
    initializeRoute,
    resetPages,
    deleteContact,
    addContact,
    setClientPhotoVerification,
    setContractorTeamMembers,
    setDynamicDispatchingCredentials,
    setBundlePricing,
} = adminWorkOrderSlice.actions;

export default adminWorkOrderSlice.reducer;
